// Dashboard Users growth page translations (en-US), loaded into dashboard.users.growth by ../en-US.users.js
module.exports = {
  menu: "Growth",
  title: "User Growth",
  description: "New users in the period and how the base evolves.",
  kpis: {
    newUsers: "New in the period",
    perDay: "New per day (average)",
    perWeek: "New per week (average)",
    total: "Total users",
  },
  info: {
    newUsers: "Accounts created in the period.\nSource: Firebase (profile index).",
    perDay: "Average accounts created per day in the period.\nSource: Firebase (profile index).",
    perWeek: "Average accounts created per week in the period.\nSource: Firebase (profile index).",
    total: "Accounts registered on the last day of the period.\nSource: Firebase (profile index).",
  },
  hints: {
    oneDay: "1-day period",
    shorterThan7: "period shorter than 7 days",
    total: "+{value} in the period",
  },
  modals: {
    newUsers: {
      title: "New users",
    },
  },
  panels: {
    newUsers: "New users by {gran}",
    windows: "Compared with previous periods",
    windowsNote: "Each bar has the length of the selected period; the current period in green.",
    weekday: "New users per weekday (average)",
    total: "Running total by {gran}",
    table: "Growth per indicator",
  },
  weekdays: {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday",
  },
  weekdaysShort: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },
  table: {
    columns: {
      indicator: "Indicator",
      current: "Current",
      previous: "Previous",
      change: "Change",
    },
    rows: {
      newUsers: "New users",
      installs: "Installs",
      active: "Active users (daily average)",
      deleted: "Deleted profiles",
      google: "Sign-ups with Google",
      apple: "Sign-ups with Apple",
    },
  },
  panelInfo: {
    newUsers: "Accounts created in each interval.\nSource: Firebase (profile index).",
    windows: "Accounts created in this period and in the previous ones of the same length.\nSource: Firebase (profile index).",
    weekday: "Average accounts created on each weekday in the period.\nSource: Firebase (profile index).",
    total: "Accounts registered at the end of each interval.\nSource: Firebase (profile index).",
    table: "Change of each indicator vs. the previous period.\nSource: Firebase (profile index: new, deleted, Google and Apple) and Google Analytics (installs and active users; without it, the active users come from Firebase: activity log).",
  },
};
